import { Subtitle, TextLarge, TextSmall } from "@finanedi.es/front/common/atoms"

import { LeyAntifraudeFormRepresentantesFormTemplate } from "../../../ley-antifraude-form-representantes-form-template"
import { IGetLeyAntiFraudeFormFieldsParams } from "../../interfaces"
import { EUserConfiguracionAntifraudeEstado } from "../enums"

export const leyAntiFraudeFormFields = ({
  estado,
  nif,
  razonSocial,
  handleCheckboxChange,
}: IGetLeyAntiFraudeFormFieldsParams) => {
  return [
    {
      group: "verifactuGroup",
      containerClassName: "fs-flex fs-flex-col fs-h-full",
      groupClassName: `fs-flex fs-flex-wrap fs-items-start fs-gap-3 fs-p-1 1k:fs-p-4 fs-rounded-lg fs-border fs-border-solid fs-border-gray-200`,
      fields: [
        {
          type: "checkbox",
          name: "verifactu",
          onChange: (checked: boolean) =>
            handleCheckboxChange(
              checked,
              EUserConfiguracionAntifraudeEstado.Verifactu
            ),
        },
        {
          type: "template",
          template: (
            <div className='fs-flex fs-flex-col fs-gap-2 fs-flex-1 fs-min-w-0'>
              <TextLarge
                text='Verifactu'
                className='fs-text-base'
              />
              <TextSmall
                className='!fs-text-sm'
                text='Los registros de facturación se enviarán automáticamente a la Agencia Tributaria conforme a la normativa Verifactu.'
              />
              <TextSmall
                text='Deberás mantener este sistema hasta el cierre del año natural.'
                className='!fs-text-sm fs-font-medium'
              />
            </div>
          ),
        },

        {
          type: "template",
          template: (
            <LeyAntifraudeFormRepresentantesFormTemplate
              nif={nif}
              razonSocial={razonSocial}
            />
          ),
          hidden: estado !== EUserConfiguracionAntifraudeEstado.Verifactu,
        },
        {
          type: "fileupload",
          name: "file",
          key: "file-fileupload",
          hidden: estado !== EUserConfiguracionAntifraudeEstado.Verifactu,
          className: "fs-w-full",
          label: (
            <Subtitle
              className='fs-text-sm fs-font-medium'
              text='2. Sube el PDF firmado'
            />
          ),
          title: "Subir PDF",
          layout: "vertical",
        },
      ],
    },
    {
      group: "exentoGroup",
      containerClassName: "fs-flex fs-flex-col",
      groupClassName:
        "fs-flex fs-flex-col fs-gap-3 fs-p-1 1k:fs-p-4 fs-rounded-lg fs-border fs-border-solid fs-border-gray-200",
      fields: [
        {
          type: "checkbox",
          name: "exento",
          onChange: (checked: boolean) =>
            handleCheckboxChange(
              checked,
              EUserConfiguracionAntifraudeEstado.Exento
            ),
          className:
            "fs-flex fs-flex-row-reverse fs-justify-end fs-items-center fs-gap-3",
          labelClassName: " fs-m-0",
          label: (
            <TextLarge
              className='fs-text-sm'
              text='Mi empresa está exenta'
            />
          ),
        },
        {
          type: "textarea",
          name: "motivo",
          label: "Motivo",
          placeholder: "",
          key: "motivo-textarea",
          rows: 3,
          inputClassName: "resize",
          className: "fs-w-full",
          hidden: estado !== EUserConfiguracionAntifraudeEstado.Exento,
        },
      ],
    },
    {
      type: "template",
      template: (
        <div className='fs-border-b fs-border-gray-200 fs-border-solid fs-my-2' />
      ),
    },
  ]
}
